<template>
  <div>
    <div v-if="error != ''" class="p-4">
      <ErrorMessage :message="error" />
    </div>
    <div v-else class="w-100">
      <div class="w-100 mt-4 px-4">
        <template v-if="is_load">
          <b-skeleton width="20%" height="30px"></b-skeleton>
          <b-skeleton class="mb-3" width="30%" height="20px"></b-skeleton>
          <div class="w-100 border-semi-grey mb-3 radius-6 p-4" v-for="i in 2" style="height: 220px;">
            <b-skeleton class="mb-4" width="30%" height="18px"></b-skeleton>
            <b-skeleton class="mb-1" width="40%" height="40px"></b-skeleton>
            <b-skeleton class="mb-4" width="60%" height="20px"></b-skeleton>
            <b-skeleton width="45%" height="16px"></b-skeleton>
          </div>
        </template>
        <template v-else>
          <p class="heading-6-1 mb-0">Get Reward</p>
          <p class="body-2-2-1 mb-3">Claim and enjoy!</p>
          <template v-for="(reward,reward_i) in data.reward">
            <ClaimingReward type="list" :data="reward" @detail="toggleRewarDetail"></ClaimingReward>
          </template>
        </template>
      </div>
    </div>

    <popup-detail 
      direction="bottom" 
      :show="detail.show"
      wrapper_size="mobile"
      use_max_size
      :use_footer="!(detail.data.type == 'CONCIERGE_PROMOTION' && detail.data.module.length > 1) && (detail.data.max_claim_rotation_type == 'NONE' || (detail.data.max_claim_rotation_type != 'NONE' && detail.data.used < detail.data.max_claim))"
      @close="toggleRewarDetail">
      <template v-slot:body>
        <div class="w-100 position-relative">
          <div style="height:220px;">
            <img :alt="detail.data.name" :src="detail.data.image_url" class="img-fit rounded-top-12" />
          </div>
          <div class="bg-white m-2 rounded-circle position-absolute border-semi-grey" style="display:inline-flex;padding:10px; right:10px;top:10px;" @click="toggleRewarDetail()">
            <img alt="close-icon" src="../../../assets/img/icon/close.png" width="14" />
          </div>
        </div>
        <div class="w-100 p-4">
          <div class="w-100 mb-4">
            <p class="d-block mb-2 overline text-orange text-uppercase" @click="test">{{ printModule(detail.data) }}</p>
            <p class="d-block mb-1 heading-6-1 lh-1">{{detail.data.name}}</p>
            <p class="d-block mb-0 body-2">{{ detail.data.sub_tagline }}</p>
          </div>
          <div v-if="detail.data.type == 'HOTEL_PROMOTION'" class="w-100 mb-4 p-3 light-card-shadow radius-8 border-form"> 
            <p class="mb-3 sub-heading-1-2 w-100 text-center">Invite your friends to Booking here</p>
            <div class="w-100 text-center mb-3 pb-3 border-b-semi-grey-dashed-2">
              <p class="body-3-3-1 mb-2">Show this QR-Code to your friend</p>
              <div class="d-table mx-auto radius-1 p-2 border-2-green">
                <qrcode-vue :value="detail.referal_url" :size="170" level="M" />
              </div>
            </div>
            <div class="w-100 row no-gutters">
              <div class="col-9">
                <div class="pr-2">
                  <p class="body-2-4 mb-0">Or share this link to your friends</p>
                  <p class="body-3-3-1 mb-0 text-truncate font-italic">{{ detail.referal_url }}</p>
                </div>
              </div>
              <div class="col-3">
                <button @click="$copyText(detail.referal_url, 'Successfully copied the referral link')" class="g-btn w-100 g-btn-primary g-btn-sm">Copy Link</button>
              </div>
            </div>
          </div>
          <div class="w-100 mb-4" v-if="detail.data.max_claim_rotation_type != 'NONE' && detail.data.used >= detail.data.max_claim">
            <ErrorMessage message="You have reached the claim limit for this reward"></ErrorMessage>
          </div>
          <div class="w-100 mb-4" v-if="$isNotEmpty(detail.data.description)">
            <p class="mb-2 body-1-4">Description</p>
            <p class="mb-0 body-2-2-1">{{ detail.data.description }}</p>
          </div>
          <div class="w-100 mb-4" v-if="detail.show">
            <p class="mb-2 body-1-4">You need to know</p>
            <p class="mb-1 body-2-2-1" v-for="(rule,i) in printRule(detail.data)">{{ `${i+1}. ${rule}` }}</p>
          </div>
          <div class="w-100" v-if="$isNotEmpty(detail.data.terms_and_conditions)">
            <p class="mb-2 body-1-4">Terms & Conditions</p>
            <div class="html-desc body-2-2-1" v-html="detail.data.terms_and_conditions"></div>
          </div>
          <div class="w-100 mt-4" id="reward-module" v-if="detail.data.type == 'CONCIERGE_PROMOTION' && detail.data.module.length > 1">
            <p class="mb-2 body-1-4">Where do you want to claim this reward?</p>
            <div class="p-3 radius-6 border-semi-grey mb-2"  v-for="concierge_module in detail.data.module">
              <div class="row">
                <div class="col-8 align-self-center">
                  <p class="mb-0 body-2-1">{{ concierge_module.name }}</p>
                </div>
                <div class="col-4 align-self-center" v-if="detail.data.max_claim_rotation_type == 'NONE' || (detail.data.max_claim_rotation_type != 'NONE' && detail.data.used < detail.data.max_claim)">
                  <button class="g-btn w-100 g-btn-primary g-btn-sm" @click="claimRewardPerModule(concierge_module)">Claim</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <div class="px-4 pt-4">
          <slide-unlock
          v-if="detail.data.type == 'NONE'"
          ref="vueslideunlock"
          :auto-width="true"
          :circle="true"
          :disabled="false"
          :noanimate="false"
          :width="400"
          :height="60"
          text="Slide to redeem"
          :success-text="detail.is_normal_claimed ? 'Claimed' : 'Please Wait..'"
          @completed="claimReward()"
          />
          <button v-else @click="claimReward" class="g-btn w-100 g-btn-primary g-btn-lg">Claim</button>
        </div>
      </template>
    </popup-detail>
  </div>
</template>

<script>
  import {get,post} from '@/services/index.js'
  import {mapGetters,mapMutations} from "vuex";
  import MemberCard from '@/components/hotel/concierge/member/MemberCard'
  import ClaimingReward from '@/components/hotel/general/ClaimingReward.vue';
  import SlideUnlock from "vue2-slide-unlock"
  import QrcodeVue from 'qrcode.vue'

  export default {
    components:{
      MemberCard,
      ClaimingReward,
      SlideUnlock,
      QrcodeVue
    },
    props:['membership_user_code'],
    data() {
      return {
        is_load: true,
				error: '',
				data:{
					card: {},
					reward: []
				},
        detail:{
          show: false,
          data: {},
          referal_url: '',
          is_normal_claimed: false
        },
      }
    },
    computed:{
      ...mapGetters(['getMerchant','isNotLogin','getCurrentUser']),
      guest_name(){
				if(!this.isNotLogin){
					return this.getCurrentUser.first_name+' '+(this.getCurrentUser.last_name != null ? this.getCurrentUser.last_name : '')
				}else{
					return 'Guest Name'
				}
			},
    },
    mounted(){
      this.loadData()
    },
    methods:{
      ...mapMutations(['setMembershipRewardApplied']),
      // SETUP DATA
      loadData(){
        this.is_load = true
        this.error = ''
        Promise.all([
          this.loadRewardList()
        ])
        .catch(err=>this.error=err)
        .finally(()=>{
          setTimeout(()=>{
            this.is_load = false
          },600)
        })
      },
      loadRewardList(){
				return new Promise((success,fail)=>{
	        get("CONCIERGE","membership/reward-list",{
	          merchant_id: this.getMerchant.id
	        }).then(response=>{
	          let res = response.data
	         	if(res.success){
              this.data.reward = res.data
	         		success(res.data)
	         	}else{
	         		fail(res.message)
	         	}
	        })
				})
      },

      // GENERAL
      pageTo(page){
        this.$router.push(`/${this.getMerchant.code}/${page}`)
      },
      printModule(data){
        let data_return = 'Room Booking'
        if(data.type == 'CONCIERGE_PROMOTION'){
          data_return = `${data.module[0].name}`
          if(data.module.length > 1){
            data_return += ' and more'
          }
        }
        return data_return
      },
      test(){
        console.log(this.$refs.vueslideunlock)
        this.$refs.vueslideunlock.completed()
      },
      toggleRewarDetail(data){
        this.detail.show = !this.detail.show
        this.detail.data = this.detail.show ? data : {}
        if(this.detail.show && data.type == 'HOTEL_PROMOTION'){
          let base_url = window.location.origin;
          let full_url = `${base_url}/${this.getMerchant.code}/apply-url?type=general&member_code=${this.membership_user_code}&reward_id=${data.id}`
          this.detail.referal_url = full_url
        }
      },
      claimRewardPerModule(data){
        if(typeof data == 'string'){
          this.$smoothScroll('reward-module')
        }else{
          this.setMembershipRewardApplied(this.detail.data)
          this.$router.push(`/${this.getMerchant.code}/concierge/${data.slug}`)
        }
      },
      claimReward(){
        if(this.detail.data.type == 'HOTEL_PROMOTION'){
          this.setMembershipRewardApplied(this.detail.data)
          this.$router.push(`/${this.getMerchant.code}/booking`)
        }else if(this.detail.data.type == 'CONCIERGE_PROMOTION'){
          this.setMembershipRewardApplied(this.detail.data)
          this.$router.push(`/${this.getMerchant.code}/concierge/${this.detail.data.module[0].slug}`)
        }else if(this.detail.data.type == 'NONE'){
          this.claimRewardNormal()
        }
      },
      claimRewardNormal(){
        this.detail.is_normal_claimed = false
        let fd = new FormData()
        fd.append('new_item',JSON.stringify({
          merchant_id: this.getMerchant.id
        }))
        post("CONCIERGE",`membership/reward-detail/${this.detail.data.id}/redeem`,fd).then(response=>{
          let res = response.data
          if(res.success){
            this.detail.is_normal_claimed = true
          }else{
            this.$refs.vueslideunlock.reset()
          }
        })
      },
      printRule(data){
        let return_data = []
        if(data.decrease_points > 0){
          return_data.push(`This reward requires ${data.decrease_points} ${this.$pluralWord(data.decrease_points,'point')}`)
        }
        if(data.max_claim_rotation_type == 'NONE'){
          return_data.push('There are no restrictions on claiming this reward')
        }else{
          let period = ''
          if(data.max_claim_rotation_type != 'LIFETIME'){
            if(data.max_claim_rotation_value == 1){
              period = ` per ${data.max_claim_rotation_type.toLowerCase()}`
            }else{
              period = ` every ${data.max_claim_rotation_value} ${this.$pluralWord(data.max_claim_rotation_value,data.max_claim_rotation_type.toLowerCase())}`
            }
          }
          let max_claim = `You can claim this reward ${data.max_claim} ${this.$pluralWord(data.max_claim,'time')}${period}`
          return_data.push(max_claim)
          if(data.used > 0) return_data.push(`Currently you have made claims ${data.used} ${this.$pluralWord(data.used,'time')}`)
        }
      return return_data
      }
    }
  }
</script>
<style scoped>
.card-info-wrap{
  bottom: -150px;
  left: 0px;
  right: 0px;
  height: 200px;
}
.bg-grey-gradient{
  background: rgb(235,235,235);
  background: linear-gradient(0deg, rgba(235,235,235,1) 0%, rgba(255,255,255,1) 100%);
}
</style>


// WEBPACK FOOTER //
// src/pages/general/membership/Reward.vue